import { timestamp } from "../../app/data/validate";

const resolveAddressee = addressee => Array.isArray(addressee) ? addressee : [addressee];

const sendMail = ({ db, uid, to, cc, bcc, message }) => {
    // sends a mail by adding it to the Firestore mail collection - mail addin handles it from there via sendgrid
    return new Promise(async (resolve, reject) => {
        try {
            if (!to) throw new Error('Mail must go TO someone!');
            if (!message) throw new Error('Message is required');

            const mail = {
                to: resolveAddressee(to),
                message,
                ts: timestamp(),
                uid
            }

            if (cc) {
                mail.cc = resolveAddressee(cc);
            }
            if (bcc) {
                mail.bcc = resolveAddressee(bcc);
            }

            const id = await db.insert({
                path: 'mail',
                payload: mail
            });

            resolve(id);
        }
        catch (error) {
            reject(error);
        }
    })
}

export default sendMail